export default __webpack_public_path__ + "img/41.d1d4f8.png";